
export class ReinsurerNote {
  id: number;
  reinsurerID: number;
  comment: string;
  commentDate: Date;  
  userId: string;
  isNewAdded: boolean;
}     
